<template>
    <div>
        <div>
            <div>
                <div class="flex items-center">
                    <div class="w-64 h-64">
                        <img :src="contract.logo_square_url" :alt="`${contract.name}-logo`">
                    </div>
                    <div class="flex items-center">
                        <p class="text-heading-2 font-semibold ml-24 mb">{{ contract.name }}</p>
                        <a :href="contract.url" class="text-body-sm italic ml-8">{{ contract.url }}</a>
                    </div>
                </div>
                <p>{{ contract.description }}</p>
            </div>
            <div class="border-t mt-24 mb-16"></div>
            <div>
                <div class="flex my-16">
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('general.name') }}</label>
                        <p>{{ contract.channel ? contract.channel.name : contract.name }}</p>
                    </div>
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('general.credits') }}</label>
                        <p>{{ contract.credits || $t('multi-posting.contracts.not_specified') }}</p>
                    </div>
                </div>
                <div class="flex my-16">
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('general.expiry_date') }}</label>
                        <p>{{ expiryDate || $t('multi-posting.contracts.not_specified') }}</p>
                    </div>
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('general.purchase_price') }}</label>
                        <p>{{ price || $t('multi-posting.contracts.not_specified') }} {{ contract.currency }}</p>
                    </div>
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('general.duration_days') }}</label>
                        <p>{{ contract.postingDurationDays || $t('multi-posting.contracts.not_specified') }}</p>
                    </div>
                </div>
                <div class="flex my-16">
                    <div class="min-w-140 mr-24">
                        <label class="text-body font-semibold">{{ $t('multi-posting.contract.alias') }}</label>
                        <p>{{ contract.alias || $t('multi-posting.contracts.not_specified') }}</p>
                    </div>
                </div>
            </div>
            <div class="border-t mt-24 mb-16"></div>
            <simple-button
                display="danger"
                icon="delete"
                look="text"
                @click="removingContract = true"
            >
                {{ $t('multi-posting.contracts.delete.button') }}
            </simple-button>
        </div>

        <popup-modal-confirm
            v-if="removingContract"
            :title="$t('multi-posting.contracts.delete.title')"
            :message="$t('multi-posting.contracts.delete.message')"
            :working="deleting"
            :disabled="hasOnlineCampaign && !approvedDelete"
            @close="stopRemoving"
            @confirm="removeContract"
        >
            <Checkbox v-if="hasOnlineCampaign" v-model="approvedDelete" class="mt-24">
                {{ $t('multi-posting.contracts.delete.confirm_message') }}
            </Checkbox>
        </popup-modal-confirm>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon.vue";
import {mapActions} from "pinia";
import {useMultiPostingStore} from '../../state/modules/multiPosting';
import {useNotificationsStore} from '../../state/modules/notifications';
import {ADD_NOTIFICATION} from "../../state/mutation-types";
import PopupModal from "../ui/PopupModal.vue";
import PopupModalConfirm from "../ui/PopupModalConfirm.vue";
import Checkbox from "../forms/Checkbox.vue";
import SimpleButton from "../ui/SimpleButton.vue";

export default {
    name: 'ContractDetails',
    components: {SimpleButton, Checkbox, PopupModalConfirm, PopupModal, SvgIcon},
    props: {
        contract: { type: Object }
    },
    data() {
        return {
            removingContract: false,
            deleting: false,
            approvedDelete: false,
        }
    },
    computed: {
        hasOnlineCampaign() {
            return true;
        },
        price() {
            if (this.contract && this.contract.amount) {
                return Number(this.contract.amount).toFixed(2);
            }
        },
        expiryDate() {
            if (this.contract) {
                return this.contract.expiryDate ? new Date(this.contract.expiryDate).toLocaleDateString() : null;
            }
        }
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        ...mapActions(useMultiPostingStore, ['deleteContract']),
        removeContract() {
            const successMessage = this.$t('multi-posting.contracts.delete_contract.success', { contract: this.contract.name });
            const errorMessage = this.$t('multi-posting.contracts.delete_contract.error');
            this.deleting = true;
            this.deleteContract(this.contract.contract_id)
                .then(() => this.deleting = false)
                .then(() => {
                    this.removingContract = false;
                    this.$emit('contract-removed', this.contract.contract_id)
                })
                .then(() => this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: successMessage
                }))
                .catch(() => this[ADD_NOTIFICATION]({
                    type: 'error',
                    message: errorMessage
                }));
        },
        stopRemoving() {
            this.approvedDelete = false;
            this.removingContract = false;
        }
    }
}
</script>
